import React from "react";
import { PlusIcon } from "@heroicons/react/24/solid";
import Button from "components/UI-lib/Button";
import { getHardwareImage } from "utils/brevcloud";

export const NoComputeRegistered: React.FC = () => {
  return (
    <div className="border border-zinc-800 rounded-md bg-zinc-900/30">
      <div className="flex flex-row items-center">
        <div
          className="relative overflow-hidden bg-black flex-shrink-0 mr-2 self-stretch rounded-l-md"
          style={{
            width: "25%",
            backgroundImage: `url(${getHardwareImage("dgx-spark")})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="p-3 flex-1">
          <div className="flex flex-col">
            <span className="text-sm font-medium text-neutral-300">
              No Compute Registered
            </span>
            <p className="text-xs text-neutral-500 mt-1 mb-3">
              Register your own compute to deploy this Launchable.
            </p>
            <Button
              label="Register Compute"
              type="secondary"
              size="small"
              iconLeft={<PlusIcon className="h-3 w-3" />}
              onClick={() => {}}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

